<azavista-dashboard
    *ngIf="dashboards && dashboardWidgets && renderDashboard"
    dashboardTitle="{{ 'GENERAL_DASHBOARD' | translate }}"
    [activeDashboardId]="activeDashboardId"
    [dashboards]="dashboards"
    [disableEditDashboard]="disableEditDashboard"
    [disableAddWidget]="disableAddWidget"
    [disabledWidgetActions]="disabledWidgetActions"
    [layout]="dashboardLayout"
    [widgets]="dashboardWidgets"
    [gridsterConfig]="gridsterOptions"
    [availableWidgets]="availableWidgets"
    (dashboardChanged)="dashboardChanged($event)"
    (dashboardSelected)="onDashboardSelected($event)"
    (createDashboard)="onCreateDashboard()"
    (editDashboard)="onEditDashboard()"
    (widgetCustomEvent)="onWidgetCustomEvent($event)"
></azavista-dashboard>
